import apiCall, { apiRequest } from '../../apiCall'
import requestConfigs from '../../requestConfig'
const actions = requestConfigs.controllers.Auth.actions

export const postLoginEmail = (params) => apiRequest('Auth.LoginPostEmail', { email: params.email }, `?email=${params.email}`)
export const postLogin = (params) => apiRequest('Auth.LoginPost', { ...params })
export const postLoginVerifictioncode = (params) => apiRequest('Auth.LoginPostVerifictionCode', params)
export const postLoginPassword = (params) => apiRequest('Auth.LoginPostPassword', params)
export const postRegisterEmail = (params) => apiRequest('Auth.RegisterPostEmail', { email: params.email })
// export const postRegisterEmail = (params) =>apiRequest('Auth.RegisterPostEmail',{},'?email='+params.email)
export const postRegisterVerifictionCode = (params) => apiRequest('Auth.RegisterPostVerifictionCode', { ...params })

export const postGetAllCompany = (params) => apiRequest('SaleCompany.GetAllCompany', { ...params })
export const addCompanyRequest = (params) => apiRequest('SaleCompany.Add', { ...params })
export const forgotPassword = (params) => apiRequest('Auth.ForgotPassword', { email: params })
export const registrationRequest = (params) => apiRequest('Auth.Registration', { email: params })







